import LegalPage from "./LegalPage";

function RefundPage() {
  return (
    <LegalPage
      slug="refund"
      title="Refund Policy | Vocally"
      description="Learn about Vocally's refund policy for subscription plans."
    />
  );
}

export default RefundPage;
